import React, { useRef } from 'react';
import { UrgencyBar } from '../components/ui/UrgencyBar';
import { PurchasePopup } from '../components/ui/PurchasePopup';
import { Hero } from '../components/sections/Hero';
import { SalesLetter } from '../components/sections/SalesLetter';
import { BenefitsGrid } from '../components/sections/BenefitsGrid';
import { Bonuses } from '../components/sections/Bonuses';
import { TrustBadge } from '../components/sections/TrustBadge';
import { Checkout } from '../components/sections/Checkout';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FAQ } from '../components/sections/FAQ';
import { Guarantee } from '../components/sections/Guarantee';
export function LandingPage() {
  const checkoutRef = useRef<HTMLDivElement>(null);
  const scrollToCheckout = () => {
    checkoutRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-black text-white selection:bg-yellow-500 selection:text-black" data-id="element-329">
      <UrgencyBar data-id="element-330" />

      <Hero onScrollToCheckout={scrollToCheckout} data-id="element-331" />
      <SalesLetter data-id="element-332" />
      <BenefitsGrid data-id="element-333" />
      <Bonuses data-id="element-334" />
      <TrustBadge data-id="element-335" />
      <Checkout ref={checkoutRef} data-id="element-336" />
      <Guarantee data-id="element-337" />
      <TestimonialsSection data-id="element-338" />
      <FAQ data-id="element-339" />

      <footer className="py-8 text-center text-zinc-600 text-sm bg-black border-t border-zinc-900" data-id="element-340">
        <p data-id="element-341">
          © {new Date().getFullYear()} Inteligencia Social Estratégica. Todos
          los derechos reservados.
        </p>
      </footer>

      <PurchasePopup data-id="element-342" />
    </main>;
}